import apiConfig from "@/config/apiConfig";

const rootPath = apiConfig.businessApi;


//客户区域管理
export const area = {
    list: rootPath + "/systemSettingsArea/list", // 区域列表
    delete: rootPath + "/settingsArea/remove", // 删除 - 批量删除
    saveOrUpdate: rootPath + "/settingsArea/saveOrupdate", // 新增或编辑
    detail: rootPath + "/settingsArea/detail", // 区域明细接口
    validAreaId: rootPath + "/settingsArea/validAreaId", // 区域编码唯一值校验
}
